import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DeviceReducerState, Device } from "../types";
import { deviceApi } from "../actions/devicesInQuery";

const initialState: DeviceReducerState = {
  count: 0,
  devices: {},
  selected: null,
  isWifiModalOpen: false,
};

const devicesSlice = createSlice({
  name: "devices",
  initialState,
  reducers: {
    selectDevice: (state, action: PayloadAction<Device | null>) => {
      state.selected = action.payload;
    },
    unselectDevice: (state) => {
      state.selected = null;
    },
    setWifiModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isWifiModalOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        deviceApi.endpoints.listDevices.matchFulfilled,
        (state, { payload }) => {
          state.count = payload.count;
          state.devices = payload.items.reduce(
            (o: DeviceReducerState["devices"], x) =>
              x.uuid ? { ...o, [x.uuid]: x } : o,
            {},
          );
        },
      )
      .addMatcher(
        deviceApi.endpoints.getDeviceById.matchFulfilled,
        (state, { payload }) => {
          state.selected = payload;
          if (payload.uuid) {
            state.devices[payload.uuid] = payload;
          }
        },
      )
      .addMatcher(
        deviceApi.endpoints.scheduleDeviceUpdate.matchFulfilled,
        (state, { payload, meta }) => {
          const { deviceUuid } = meta.arg.originalArgs;
          if (state.devices[deviceUuid]) {
            state.devices[deviceUuid].will_update = payload.will_update;
          }
          if (state.selected?.uuid === deviceUuid) {
            state.selected.will_update = payload.will_update;
          }
        },
      )
      .addMatcher(
        deviceApi.endpoints.displayNameUpdate.matchFulfilled,
        (state, { payload, meta }) => {
          const { deviceUuid } = meta.arg.originalArgs;
          if (state.devices[deviceUuid]) {
            state.devices[deviceUuid].display_name = payload.display_name || "";
          }
          if (state.selected?.uuid === deviceUuid) {
            state.selected.display_name = payload.display_name || "";
          }
        },
      );
  },
});

export const { selectDevice, unselectDevice, setWifiModalOpen } =
  devicesSlice.actions;
export default devicesSlice.reducer;
